<div class="loading-overlay" *ngIf="isLoading" [style.background]="overlayColor">
  <mat-spinner 
    [diameter]="spinnerDiameter" 
    [style.color]="spinnerColor">
  </mat-spinner>
  <span class="loading-message">{{ message }}</span>
</div>
